<template>
  <div>
    <base-header :pageName="title" :popup="true" :bfClose="true" v-on:beforeClose="onHeaderClose"></base-header>
    <section id="wrap">
        <div class="popCont" v-html="cntn"></div>
    </section>
    <div class="todayView" v-if="ppupTyp === '0'">
        <span class="checkbox">
            <input type="checkbox" 
              name="" 
              id="Today"
              v-model="saved">
            <label for="Today">오늘하루열지않음</label>
        </span>
        <button type="button" @click.enter="onSave">닫기</button>
    </div>
    <div class="todayView"  v-else>
        <span class="checkbox">
            <input type="checkbox" 
              name="" 
              id="Today"
              v-model="saved">
            <label for="Today">다시열지않음</label>
        </span>
        <button type="button" @click.enter="onSave">닫기</button>
    </div>
    
  </div>
</template>

<script>
var parser = new DOMParser();

export default {
  components: {
  },
  data() {
    return {      
      sqno: 0,
      ppupTyp: '',
      title: '',
      cntn: '',
      saved: false
    };
  },
  metaInfo: {
    title: '팝업',
    meta: [
      { charset: 'utf-8' },
      { vmid: 'viewport', name: 'viewport', content: 'width=device-width,initial-scale=1.0,minimum-scale=1.0,user-scalable=yes' }
    ],
  },
  methods: {
    getPopInfo() {
      var that = this;
      var param = {};
      param.sqno = this.sqno;
      this.$api.popup.detail(param)
        .then(function (detail) {
          console.log(
            "Popup.vue <api.popup.detail.response>",
            detail
          );
          that.sqno = detail.sqno;
          that.title = parser.parseFromString(detail.titl, "text/html").body.innerText;
          that.ppupTyp = detail.ppupTyp;
          that.cntn = parser.parseFromString(detail.cntn, "text/html").body.innerText;
        })
        .catch(function (error) {
          alert(error.rtMsg);
        });
    }, 
    onSave() {
      if(!this.saved) {
        this.$utils.nativeIf.outbound.close(false);
        return;
      }

      this.sendClosedPop();
    },
    onHeaderClose() { // 헤더 X 버튼: 체크되어 있으면 저장. 창 닫기는 BaseHeader 가 이어서 처리
      if(this.saved) {
        this.sendClosedPop();
      }
    },
    sendClosedPop() { // 닫은 팝업 정보를 부모(Main.vue)로 전달 -> SET_POP 저장
      var popup = {};
      popup.sqno = this.sqno;
      popup.ppupTyp = this.ppupTyp;
      popup.dt = this.$utils.date.yyyymmdd();

      var child = {
        name: "popup",
        data: popup
      };
      this.$utils.nativeIf.outbound.sendChildData(child);
    }
  },
  created: function () {
    this.sqno = Number(this.$route.params.id);
    this.getPopInfo();
  },
  beforeUpdate: function () {},
};
</script>
